export function readCache<T>(key: string): T | null {
  const value = localStorage.getItem(key);

  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch {
    localStorage.removeItem(key);
    return null;
  }
}

export function writeCache<T>(key: string, value: T) {
  localStorage.setItem(key, JSON.stringify(value));
}
